export default "__VITE_ASSET__DTc8ohZL__"